export interface AddOutcomeParams {
  /** Existing market pubkey (base58). */
  readonly marketPubkeyBase58: string;
  /** MarketConfig bound to the market. */
  readonly marketConfigBase58: string;
  /** Bound schedule for timed markets; null for conviction markets. */
  readonly eventScheduleBase58: string | null;
  /** Next active index; must equal the market's current n_outcomes. */
  readonly outcomeIndex: number;
  /** Token metadata display name. */
  readonly name: string;
  /** Token metadata symbol. */
  readonly symbol: string;
  /** Editorial ticker used for promotion matching and diagnostics. */
  readonly ticker: string;
  /** Pinned token metadata URI. */
  readonly uri: string;
}

export interface AddOutcomeProgressState {
  readonly status: 'idle' | 'preparing' | 'outcome' | 'done' | 'failed';
  /** Deterministic outcome mint derived from market and outcome index. */
  readonly outcomeMintBase58: string | null;
  /** Signature of the atomic add-and-prepare transaction. */
  readonly outcomeSubmitted: string | null;
  /** True after the add-and-prepare transaction confirms. */
  readonly outcomeConfirmed: boolean;
  /** Last error if `status === 'failed'`. */
  readonly error: { stage: AddOutcomeProgressState['status']; message: string } | null;
}

export interface AddOutcomeResult {
  readonly marketPubkey: string;
  readonly outcomeIndex: number;
  readonly outcomeMintBase58: string;
  readonly signature: string;
}

export const INITIAL_ADD_OUTCOME_PROGRESS_STATE: AddOutcomeProgressState = {
  status: 'idle',
  outcomeMintBase58: null,
  outcomeSubmitted: null,
  outcomeConfirmed: false,
  error: null,
};
